import { render } from "./HBEPoints.vue?vue&type=template&id=4c4e930f&scoped=true"
import script from "./HBEPoints.vue?vue&type=script&lang=js"
export * from "./HBEPoints.vue?vue&type=script&lang=js"

import "./HBEPoints.vue?vue&type=style&index=0&id=4c4e930f&scoped=true&lang=css"

import exportComponent from "/cwt/data/jenkins/workspace/RoomIt-HotelWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c4e930f"]])

export default __exports__